import { Component, ElementRef } from '@angular/core';
import { IIcBaseComponent, IcBaseStandaloneComponent } from './ic-base-standalone.component';

@Component({
  selector: 'ic-gmx-standalone',
  templateUrl: '../templates/gmx.svg'
})
export class IcGmxComponent extends IcBaseStandaloneComponent implements IIcBaseComponent {
  defaultWidth = 20;
  defaultHeight = 20;

  constructor(elmRef: ElementRef<HTMLElement>) {
    super(elmRef);
  }
}
